/**
 * Default tooltip props used by form field components (e.g. label info icon).
 * Reuse this so all fields share the same tooltip placement and size.
 */
export const DEFAULT_TOOLTIP_PROPS = {
	position: 'top-left',
	tooltipSize: 'large',
	minWidth: '264px',
	offset: 16
} as const
